import {
  deleteSearchAlert
} from "./chunk-ZMHFAQNV.js";
import {
  getConfigWithMetadata,
  hasAuthorization
} from "./chunk-NFLWKIRZ.js";
import {
  getErrorResult
} from "./chunk-IPNO7PON.js";

// src/services/deleteSearchAlert/deleteSearchAlert.ts
async function deleteSearchAlert2(searchAlertId, apiConfig) {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, "deleteSearchAlert");
    if (!hasAuthorization(_apiConfig)) {
      console.warn(
        "JWT token is required. Please provide a valid JWT token in the `apiConfig` via `jwtToken` or `headers.Authorization` or provide a `getToken` function in the `apiConfig`"
      );
    }
    await deleteSearchAlert(searchAlertId, _apiConfig);
    return { status: "success", data: void 0 };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}

export {
  deleteSearchAlert2 as deleteSearchAlert
};
